import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const ITEMS = [
  { to: "/admin", label: "Overview", end: true },
  { to: "/admin/artworks", label: "Artworks" },
  { to: "/admin/collections", label: "Collections" },
  { to: "/admin/journal", label: "Journal" },
  { to: "/admin/orders", label: "Orders" },
  { to: "/admin/messages", label: "Messages" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen grid grid-cols-1 md:grid-cols-[260px_1fr] bg-background" data-testid="admin-layout">
      <aside className="border-r border-border p-8 md:sticky md:top-0 md:h-screen">
        <Link to="/admin" className="font-serif text-2xl block mb-2">Susan Denny</Link>
        <p className="eyebrow text-muted-foreground mb-12">Studio</p>

        <nav className="flex flex-col gap-4 mb-auto">
          {ITEMS.map((i) => (
            <NavLink
              key={i.to}
              to={i.to}
              end={i.end}
              data-testid={`admin-nav-${i.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm tracking-wide transition-colors ${isActive ? "text-foreground" : "text-muted-foreground hover:text-foreground"}`
              }
            >
              {i.label}
            </NavLink>
          ))}
        </nav>

        <div className="mt-16 pt-8 border-t border-border text-xs">
          <p className="text-muted-foreground mb-1">Signed in</p>
          <p className="mb-3">{user?.email}</p>
          <div className="flex gap-4">
            <Link to="/" className="hair-link">View site</Link>
            <button
              onClick={() => { logout(); navigate("/admin/login"); }}
              className="hair-link"
              data-testid="admin-logout"
            >
              Sign out
            </button>
          </div>
        </div>
      </aside>
      <main className="p-8 md:p-14">
        <Outlet />
      </main>
    </div>
  );
}
